// extracted by mini-css-extract-plugin
module.exports = {"select-loader":"loadingCard_select-loader__1fnWT","switch-loader":"loadingCard_switch-loader__1tVa0"};